<template>
  <div>
    <div class="col-xs-3 col-sm-2 col-md-1" v-if="!advanced">
      <input
        type="number"
        min="0"
        class="form-control m-b-0"
        v-model.number="allTime"
        @input="allTimeChange"
        ng-readonly="vm.isReadOnly"
        @wheel="$event.target.blur()"
      />
    </div>
    <div class="pull-left p-l-15 m-r-15">
      <button
        type="button"
        class="btn btn-success btn-sm width-100"
        @click="togleAdvanced"
      >
        <span
          v-if="!advanced"
          v-t="'TARGET_CONCURRENCY_ADVANCED_BUTTON'"
        ></span>
        <span v-if="advanced" v-t="'TARGET_CONCURRENCY_BASIC_BUTTON'"></span>
      </button>
    </div>
    <button
      v-t="'RESET'"
      type="button"
      class="btn btn-primary btn-sm m-r-10"
      @click="resetMatrix"
    />
    <HourlyDayMatrix
      v-if="matrixData && advanced"
      :matrix="matrixData"
      :allDays="allDays"
      :allHours="allHours"
      :allTime="allTime"
      @matrixNeedsUpdate="matrixNeedsUpdate"
      @matrixHourNeedsUpdate="matrixHourNeedsUpdate"
      @matrixDayNeedsUpdate="matrixDayNeedsUpdate"
    />
  </div>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import HourlyDayMatrix from '@/core/components/HourlyDayMatrix';
import { targetService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'HourlyDaySelector',
  components: {
    HourlyDayMatrix
  },
  props: {
    matrix: {
      type: Array,
    },
  },
  data: function () {
    var vm = {
      advanced: false,
      allTime: {
        type: Number,
        default: undefined,
      },
      allDays: [],
      allHours: [],
      matrixData: [],
    };
    
    if (this.matrix) {
      vm.matrixData = targetService.cloneMatrix(this.matrix);
    }
    this.fillVm(vm);
    return vm;
  },
  watch: {
    matrix: function (newVal, oldVal) {
      if (newVal && Array.isArray(newVal)) {
        this.matrixData = targetService.cloneMatrix(newVal);
      } else {
        this.matrixData = undefined;
      }

      this.fillVm(this);
    },
  },
  beforeCreate: function () {
    this.daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    this.hours = _.range(24);
  },
  methods: {
    fillVm: function (vm) {
      vm.advanced = false;
      vm.allTime = undefined;
      vm.allDays = [];
      vm.allHours = [];

      if (this.matrix && this.matrix.length > 0) {
        for (var day = 0; day < this.matrix.length; day++) {
          if (this.allSameInRow(this.matrix, day)) {
            vm.allDays[day] = this.matrix[day][0];
          } else {
            vm.allDays[day] = undefined;
            vm.advanced = true;
          }
        }
        for (var hour = 0; hour < this.matrix[0].length; hour++) {
          if (this.allSameInColumn(this.matrix, hour)) {
            vm.allHours[hour] = this.matrix[0][hour];
          } else {
            vm.allHours[hour] = undefined;
            vm.advanced = true;
          }
        }
        if (!vm.advanced) {
          vm.allTime = this.matrix[0][0];
        }
      }
    },
    allSameInRow: function (matrix, row) {
      const compareDay = matrix[row][0];
      for (var hour = 0; hour < matrix[row].length; hour++) {
        const element = matrix[row][hour];
        if (!_.isEqual(compareDay, element)) {
          return false;
        }
      }
      return true;
    },
    allSameInColumn: function (matrix, col) {
      const compareDay = matrix[0][col];
      for (var day = 0; day < matrix.length; day++) {
        const element = matrix[day][col];
        if (!_.isEqual(compareDay, element)) {
          return false;
        }
      }
      return true;
    },
    togleAdvanced: function () {
      if(this.matrixData?.length==0){
        //ensure if its going to be advanced that we have a matrix.
        this.matrixData = targetService.newEmptyMatrix();
      }
      if (this.advanced) {
        //if it's moving to basic, reset the matrix
        this.resetMatrix();
      }
      this.advanced = !this.advanced;
    },
    allTimeChange: function () {
      this.matrixData = new Array();
      for (var day = 0; day < this.daysOfWeek.length; day++) {
        this.matrixData[day] = new Array();
        for (var hour = 0; hour < this.hours.length; hour++) {
          if (isNaN(this.allTime) || this.allTime == '') {
            this.matrixData[day].push(undefined);
          } else {
            this.matrixData[day].push(parseInt(this.allTime));
          }
        }
      }
      this.$emit('matrixUpdated', this.matrixData);
    },
    matrixHourNeedsUpdate: function (updateData) {
      for (var day = 0; day < 7; day++) {
        this.matrixData[day][updateData.hour] = updateData.value;
      }
      this.$emit('matrixUpdated', this.matrixData);
    },
    matrixDayNeedsUpdate: function (updateData) {
      for (var hour = 0; hour < 24; hour++) {
        this.matrixData[updateData.day][hour] = updateData.value;
      }
      this.$emit('matrixUpdated', this.matrixData);
    },
    matrixNeedsUpdate: function (updateData) {
      this.matrixData[updateData.day][updateData.hour] = updateData.value;
      this.$emit('matrixUpdated', this.matrixData);
    },
    resetMatrix: function () {
      this.matrixData = targetService.newEmptyMatrix();
      this.$emit('matrixUpdated', this.matrixData);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>